/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Noresults1Inputs */

const he_common_noresults1 = /** @type {(inputs: Common_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נמצאו תוצאות.`)
};

const en_common_noresults1 = /** @type {(inputs: Common_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

/**
* | output |
* | --- |
* | "No results found." |
*
* @param {Common_Noresults1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_noresults1 = /** @type {((inputs?: Common_Noresults1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Noresults1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_noresults1(inputs)
	return en_common_noresults1(inputs)
});
export { common_noresults1 as "common_noResults" }